// extracted by mini-css-extract-plugin
export default {"auth":"jS_vZASNmdSc3SCBfWBq","auth__form":"QebDguRe05EQCrywdBe2","authForm":"QebDguRe05EQCrywdBe2"};